/**
 * WARNING: This file was auto-generated by svgr. Do not edit.
 */
import * as React from 'react'
import type { SVGProps } from 'react'
/**
 * @internal
 */
const SvgParticipantsFilled = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={18} height={18} fill="none" {...props}>
    <path
      fill="#FF2929"
      d="M11.7 8.25c1.12 0 2.018-1.005 2.018-2.25S12.82 3.75 11.7 3.75 9.675 4.755 9.675 6s.904 2.25 2.025 2.25m-5.4 0c1.12 0 2.018-1.005 2.018-2.25S7.42 3.75 6.3 3.75 4.275 4.755 4.275 6 5.179 8.25 6.3 8.25m0 1.5c-1.573 0-4.725.877-4.725 2.625v1.875h9.45v-1.875c0-1.748-3.152-2.625-4.725-2.625m5.4 0c-.196 0-.418.015-.655.037.783.63 1.33 1.478 1.33 2.588v1.875h4.05v-1.875c0-1.748-3.152-2.625-4.725-2.625"
    />
  </svg>
)
export default SvgParticipantsFilled
